module.exports = __webpack_public_path__ + "img/11.e172d11d.svg";